var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onChange}},[_c('div',{staticClass:"radio-v3__tick"}),_c('div',{staticClass:"radio-v3__label"},[_vm._t("label")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }